import React, { useEffect } from "react";
import ReportUtils from "../../../../../utils/report-utils.js";
import { navigateHook } from "../../../../../hooks/use-navigate.js";

const ReportContent = ({data = [], boName, showDisplacement, tableColumns,}) => {
    const navigate = navigateHook();

    useEffect(() => {
        const exportColumns = [
            {id: "protocol", label: "Protocolo", value: (item) => item.attendance_protocol ?? ""},
            {id: "dispatch", label: "Despacho", value: (item) => item.dispatch_numbercheckbook ?? "Sem talão"},
            {id: "bo", label: boName, value: (item) => item.dispatch_occurrencenumber ?? ""},
            {id: "dispatch", label: "Atividade programada", value: (item) => item.garrisonschedule_id ? "Sim" : "Não"},
            {id: "dateTime", label: "D/H inicial", value: (item) => item.dispatch_date_start ?? ""},
            {id: "dateTime", label: "D/H final", value: (item) => item.dispatch_date_end ?? ""},
            {id: "nature", label: "Natureza", value: (item) => item.dispatch_nature ?? ""},
            {id: "source", label: "Origem", value: (item) => item.source ?? ""},
            {id: "providence", label: "Providência", value: (item) => item.dispatch_providence ?? ""},
            {id: "address", label: "Local pré-cadastrado", value: (item) => item.dispatch_factplace ?? ""},
            {id: "address", label: "Endereço", value: (item) => item.dispatch_factstreet ?? ""},
            {id: "address", label: "Número", value: (item) => item.dispatch_factnumber ?? ""},
            {id: "address", label: "Bairro", value: (item) => item.dispatch_factneighborhood ?? ""},
            {id: "address", label: "Setor", value: (item) => item.dispatch_sectors ?? ""},
            {id: "garrison", label: "Guarnição", value: (item) => item.garrison_name ?? ""},
            {id: "garrison", label: "Equipe", value: (item) => item.garrison_team ?? ""},
            {id: "garrison", label: "Contingentes", value: (item) => item.contingent_namewar ?? ""},
            {id: "initialObservation", label: "Obs. inicial", value: (item) => item.dispatch_initialobservation ?? ""},
            {id: "finalObservation", label: "Obs. final", value: (item) => item.dispatch_finalobservation ?? ""},
        ].filter((column) => tableColumns?.[column.id]?.visible !== false);

        const labels = exportColumns.map((column) => column.label);
        const values = data.map((item) => exportColumns.map((column) => column.value(item)));

        ReportUtils.createExportableTable(labels, values, "Sequência de despachos");
    }, [data, boName, tableColumns]);

    const address = (item) => (
        <>
            {item.dispatch_factplace}
            {item.dispatch_factplace && <br />}
            {[item.dispatch_factstreet, item.dispatch_factnumber].filter(Boolean).join(", ")}
            {item.dispatch_factneighborhood &&
            (item.dispatch_factstreet || item.dispatch_factplace) ? " - " : ""}
            {item.dispatch_factneighborhood}
            {item.dispatch_sectors && ` (${item.dispatch_sectors})`}
        </>
    );
    const garrison = (item) => (
        <>
            {item.garrison_name}
            <br />
            {item.garrison_team && (
                <>
                    <b>Equipe: </b>
                    {item.garrison_team}
                    <br />
                </>
            )}
            {item.contingent_namewar && (
                <>
                    <b>Contingentes: </b>
                    {item.contingent_namewar}
                </>
            )}
        </>
    );
    const columns = [
        {
            id: "protocol",
            render: (item) => (
                <p onClick={() => navigate(`/despacho/attendance/form/${item.attendance_id}`, true)} className="report-link">
                    {item.attendance_protocol ?? ""}
                </p>
            ),
        },
        {
            id: "dispatch",
            render: (item) => (
                <>
                    {item.dispatch_numbercheckbook ? (
                        <p onClick={() => navigate(`/despacho/dispatch/form/${item.dispatch_id}`, true)} className="report-link">
                            {item.dispatch_numbercheckbook}
                        </p>
                    ) : (
                        "Sem talão"
                    )}
                    {item.garrisonschedule_id && (
                        <>
                            <br />
                            <span className="font-bold">Atividade programada</span>
                        </>
                    )}
                </>
            ),
        },
        {
            id: "bo",
            render: (item) => (
                <p onClick={() => navigate(item.dispatch_occurrencenumber ? `/bo/redirect/${item.dispatch_occurrencenumber.replace("/", "-")}` : "", true,)} className="report-link">
                    {item.dispatch_occurrencenumber ?? ""}
                </p>
            ),
        },
        { id: "dateTime", render: (item) => `${item.dispatch_date_start ?? ""}${item.dispatch_date_end ? ` até ${item.dispatch_date_end}` : ""}` },
        { id: "nature", render: (item) => item.dispatch_nature },
        { id: "source", render: (item) => item.source },
        { id: "providence", render: (item) => item.dispatch_providence ?? "" },
        { id: "address", render: address },
        { id: "garrison", render: garrison },
        { id: "initialObservation", render: (item) => item.dispatch_initialobservation ?? "" },
        { id: "finalObservation", render: (item) => item.dispatch_finalobservation ?? "" },
    ];

    const visibleColumns = columns.filter(
        (column) => tableColumns?.[column.id]?.visible !== false,
    );

    return (
        <>
            {visibleColumns.length ? (
                <table id="dispatch-sequence-data" className="table report-table" sheet-name="Sequência de despachos">
                    <thead className="thead-background">
                        <tr className="bg-[#f6f6f6] text-left">
                            {visibleColumns.map((column) => (
                                <th key={column.id}>{tableColumns[column.id].label}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className="bg-white">
                        {data.map((item, index) => (
                            <React.Fragment key={index}>
                            <tr className={showDisplacement ? "details-row" : ""}>
                                    {visibleColumns.map((column) => (
                                        <td key={column.id}>{column.render(item)}</td>
                                    ))}
                                </tr>

                                {showDisplacement && item.displacements?.length > 0 && (
                                    <tr>
                                        <td colSpan={visibleColumns.length}>
                                            <table className="table report-table">
                                                <thead className="thead-background">
                                                    <tr className="!bg-[#f6f6f6] text-left">
                                                        <th>Local pré-cadastrado</th>
                                                        <th>Endereço</th>
                                                        <th>Bairro</th>
                                                        <th>D/H</th>
                                                        <th>KM</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {item.displacements.map(
                                                        (displacement, displacementIndex) => (
                                                            <tr key={displacementIndex}>
                                                                <td>
                                                                    {displacement.displacement_destiny ?? ""}
                                                                </td>
                                                                <td>
                                                                    {displacement.displacement_street ?? ""}
                                                                </td>
                                                                <td>
                                                                    {displacement.displacement_neighborhood ?? ""}
                                                                </td>
                                                                <td>
                                                                    {displacement.displacement_goingdate}
                                                                    {displacement.displacement_arrivaldate && ` até ${displacement.displacement_arrivaldate}`}
                                                                </td>
                                                                <td>
                                                                    {displacement.displacement_goingmileage}
                                                                    {displacement.displacement_arrivalmileage && ` até ${displacement.displacement_arrivalmileage}`}
                                                                </td>
                                                            </tr>
                                                        ),
                                                    )}
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                )}
                            </React.Fragment>
                        ))}
                    </tbody>
                </table>
            ) : (
                <div id="noDataMessage" className="alert alert-info p-2 h6 text-center">
                    Todas as colunas foram ocultadas.
                </div>
            )}

            <div id="chart-tables"/>
        </>
    );
};

export default ReportContent;